import { createActionWithPayload } from "store/helpers";
import { ActionTypes, ConfiguracoesEducador } from "./types";

export const set = createActionWithPayload<Partial<ConfiguracoesEducador>>(
  ActionTypes.SET
);
